import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forOwn, omit } from './object'; // 将相对地址转换为绝对地址

export function toAbsolute(url) {
  var a = document.createElement('a');
  a.href = url;
  return a.href;
} // 将对象转化问URI字符串

export function encodeObject(obj) {
  var retVal = '';
  var i = 0;
  forOwn(obj || {}, function (value, key) {
    if (value !== undefined) {
      i++ && (retVal += '&');
      retVal += encodeURIComponent(key);
      retVal += '=';
      retVal += encodeURIComponent(value);
    }
  });
  return retVal;
} // 解析配对连接字符串,如name=tom&class=2&grade=3

function parsePairString(str, split1, split2, doPair) {
  str.split(split1).forEach(function (searchPair) {
    var keyValue = searchPair.split(split2);
    doPair(keyValue[0], keyValue[1]);
  });
} // 为字符串提供url解析功能


var regUrl = /(?:((?:[^:/]*):)\/\/)?([^:/?#]*)(?::([0-9]*))?(\/[^?#]*)?(\?[^#]*)?(#.*)?/;

function URL(str) {
  if (regUrl.test(str)) {
    this.protocol = RegExp.$1;
    this.hostname = RegExp.$2;
    this.port = RegExp.$3;
    this.pathname = RegExp.$4;
    this.search = RegExp.$5;
    this.hash = RegExp.$6;
  }
} // noinspection JSUnusedGlobalSymbols
// eslint-disable-next-line no-multi-assign


URL.prototype.inspect = URL.prototype.valueOf = URL.prototype.toString = URL.prototype.toJSON = function () {
  return this.href;
};

Object.defineProperties(URL.prototype, {
  href: {
    get: function get() {
      return this.origin + this.pathname + this.search + this.hash;
    }
  },
  host: {
    get: function get() {
      return this.hostname + (this.port ? ":".concat(this.port) : '');
    }
  },
  origin: {
    get: function get() {
      return this.protocol ? "".concat(this.protocol, "//").concat(this.host) : this.host;
    }
  },
  params: {
    get: function get() {
      var arg = {};
      parsePairString(this.search.substring(1), '&', '=', function (key, value) {
        key !== '' && (arg[decodeURIComponent(key)] = decodeURIComponent(value));
      });
      return arg;
    }
  }
});
export function parse(str) {
  return new URL(str);
} // 更改部分url

export function modify(url, part) {
  url = parse(url);
  Object.assign(url, part);
  return url.toString();
}

function newSearch(url, search) {
  return url.origin + url.pathname + (search ? '?' : '') + search + url.hash;
}

export function addParams(url, params) {
  url = parse(url);
  return newSearch(url, encodeObject(_objectSpread(_objectSpread({}, url.params), params)));
}
export function removeParams(url, params) {
  url = parse(url);
  return newSearch(url, encodeObject(omit(url.params, params)));
}